import { jsx as r } from "react/jsx-runtime";
import { Container as i } from "./styles.js";
const l = ({ children: e, animated: a = !1, description: o, className: t }) => /* @__PURE__ */ r(i, { $animated: a, "aria-label": o, className: t, children: e });
l.displayName = "Skeleton";
export {
  l as Skeleton
};
//# sourceMappingURL=Skeleton.js.map
